import { render } from "./DownloadFile.vue?vue&type=template&id=51c09044&scoped=true"
import script from "./DownloadFile.vue?vue&type=script&lang=ts"
export * from "./DownloadFile.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-51c09044"

export default script